import track from './track';
import getProductData from './get-product-data';

/**
 * Track a product detail page
 * @param {IProduct} product
 */
export default function productDetail(product) {
    const data = getProductData(product);
    // the client doesn't want this value here
    delete data.quantity;
    return track({
        event: 'productView',
        ecommerce: {
            currencyCode: 'CHF',
            detail: {
                products: [data],
            },
        },
    });
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/tracking/product-detail.js